var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCatProfileEmpty = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#cat-profile-empty_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#C7ABDA",
  d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#835FA3",
  d: "M9.222 8.306C7.667 6.94 5.128 4.508 3.634 5.556c-1.493 1.05 1.536 6.49 1.536 6.49-.423 2.94-.114 4.846 2.493 6.128C7.08 23.727.373 22.728.89 30.484c.115.853.611 2.54 1.578 3.488.93.913 2.006 1.415 3.883 1.476 1.28.124 2.953-.013 2.363-1.012.467.002.978.035.978.035.378.8.627 1.06 1.46 1.05.863-.02 1.152-.847 1.123-1.104l.238.042s.056 1.24 1.4 1.228c.84-.082 1.041-.755 1.041-.755s1.68.556 2.7.531 1.424-.432.975-1.11c-.45-.68-2.364-1.004-2.364-1.004.92-1.621 4.87-5.086 2.543-7.368 1.9-4.182 1.08-8.089-.082-11.064 1.335-1.96 1.637-4.028-1.652-6.92-.987-4.923-2.177-6.539-3.315-6.256s-1.981 3.414-2.103 5.361c-1.215.417-2.433 1.204-2.433 1.204"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "cat-profile-empty_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12"
})))));
export default SvgCatProfileEmpty;